import React from 'react';
import { Link } from 'react-router-dom';
import './css/NotFoundPage.css';
import { HomeButton } from '../components/website/HomeButton';
export const NotFoundPage = () => {
    return (
        <div className="not-found-page">
            <HomeButton />
            <h2 className="not-found-page-title">Uh oh, the link you are looking for does not exist.</h2>
            <p className="not-found-page-text">Please check the URL and try again.</p>
            <Link to="/" className="btn btn-custom">To the home page</Link>
        </div>
    );
};

export default NotFoundPage;